import { render, staticRenderFns } from "./FAQPanel.vue?vue&type=template&id=da070408&scoped=true"
import script from "./FAQPanel.vue?vue&type=script&lang=js"
export * from "./FAQPanel.vue?vue&type=script&lang=js"
import style0 from "./FAQPanel.vue?vue&type=style&index=0&id=da070408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da070408",
  null
  
)

export default component.exports